import type { TemplateVersionInfo } from '../../types/templateModel'
import type { useTimelineScale } from '../versionedTimeline/useTimelineScale'
import { MultipleTemplateVersionsCircle } from './MultipleTemplateVersionsCircle'
import { SingleTemplateVersionCircle } from './SingleTemplateVersionCircle'

type Props = {
  versions: TemplateVersionInfo[]
  dateToPixel: ReturnType<typeof useTimelineScale>['dateToPixel']
  isInherited: (version: TemplateVersionInfo) => boolean
  currentVersionLineId: string
  earliestVersionDate: Date
}

export const TemplateVersionsForDate = ({
  versions,
  dateToPixel,
  isInherited,
  currentVersionLineId,
  earliestVersionDate,
}: Props) => {
  const nonInheritedVersions = versions.filter(
    (version) => !isInherited(version),
  )

  const isConflictPresent = nonInheritedVersions.length > 1

  return isConflictPresent ? (
    <MultipleTemplateVersionsCircle
      versions={nonInheritedVersions}
      currentVersionLineId={currentVersionLineId}
      dateToPixel={dateToPixel}
      earliestVersionDate={earliestVersionDate}
    />
  ) : (
    <SingleTemplateVersionCircle
      version={versions[versions.length - 1]}
      dateToPixel={dateToPixel}
      isInherited={isInherited}
      currentVersionLineId={currentVersionLineId}
      earliestVersionDate={earliestVersionDate}
    />
  )
}
